<template>
    <v-card elevation="0" class="pa-4">
        <pie-chart
            :chart-data="pieData"
            :options="OfertasTipoOptions"
            @generated="setLegend"
        ></pie-chart>

        <!-- <div  id="chartjs-legend">
            <v-chip v-for="item in message"
                v-bind:key="item.label"
                :color="item.color"
                outlined
            >
            {{ item.label }}
            </v-chip>
        </div> -->
    </v-card>
</template>

<script>
import PieChart from './PieChart.js';
import { preparePieData } from '@/util/prepareChartData.js';
import { mapState, mapActions } from 'vuex';

export default {
    name: 'ComercialesTableSingleStats',
    components: {
        PieChart,
    },
    data: () => ({
        a: null,
        message: '',
        OfertasTipoOptions: {
            maintainAspectRatio: false,
            responsive: true,
            legend: {
                display: true,
                position: 'bottom',
                align: 'start',
            },
            legendCallback: function (chart) {
                var arr = [];
                for (var i = 0; i < chart.data.datasets[0].data.length; i++) {
                    if (chart.data.labels[i]) {
                        arr.push({
                            label: chart.data.labels[i],
                            color: chart.data.datasets[0].backgroundColor[i],
                        });
                    }
                }
                return arr;
            },
        },
    }),
    computed: {
        pieData() {
            let data = {};
            for (let element in this.currentComercial) {
                data[element.replace('num_', '').replace('_', ' ')] =
                    this.currentComercial[element];
            }
            delete data['atenciones'];
            delete data['ventas_valor'];
            delete data['atenciones_vendidas'];

            return preparePieData(data, '');
        },
        ...mapState('gerencia', {
            currentComercial: (state) => state.currentComercial,
        }),
    },
    methods: {
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        setLegend(html) {
            this.message = html;
        },
        ...mapActions('util', ['processPieData']),
    },
};
</script>